import { graphql } from '../gql';

export const checkRelogin = graphql(`
  query checkRelogin {
    checkReloginQuery {
      needsRelogin
      error {
        code
        details {
          codeAsString
          message
        }
        message
      }
    }
  }
`);
